<template>
  <div>
    <el-form ref="formRef" :model="caseForm" label-width="110px">
      <el-form-item label="文章标题：">
        <el-input v-model="caseForm.title" placeholder="请输入文章标题" style="width:26em;"/>
      </el-form-item>
      <el-form-item label="文章内容：">
        <vue-ueditor-wrap v-model="caseForm.content" :config="editorConfig" editor-id="editor-demo-01"></vue-ueditor-wrap>
      </el-form-item>
      <el-form-item label="分享内容：">
        <el-input :autosize="{ minRows: 3, maxRows: 6}" type="textarea" v-model="caseForm.shareContent" placeholder="请输入分享内容" style="width:26em;"/>
      </el-form-item>
      <el-form-item label="初始浏览量：">
        <el-input v-model="caseForm.pageViewShow" placeholder="请输入整数" style="width:26em;"/>
      </el-form-item>
      <el-form-item label="展示页面：">
        <el-select v-model="type" placeholder="Select" style="width: 26em">
          <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="展示时间：">
        <el-date-picker
            v-model="showTime"
            type="datetime"
            placeholder="Pick a day"
            :shortcuts="shortcuts_t"
            style="width: 26em"
        />
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData } from "@/api/api"
import { addOrUpdateSuccessfulCase } from "@/api/url";

export default {
  name: "editCaseDialog",
  props: {
    value: Object
  },
  data() {
    return {
      caseForm: this.value.caseForm,
      idx: this.value.ids,
      loading: false,

      showTime: this.value.caseForm.showTime?new Date(this.value.caseForm.showTime):new Date(),

      typeArray: [
        {label: '仅成功案例展示', value: 1},
        {label: '仅帮我约ta展示', value: 2},
        {label: '都展示', value: 0}
      ],
      type: this.value.ids > -1 ? this.value.caseForm.type : 1,

      editorConfig: {
        autoHeightEnabled: false,
        initialFrameHeight: 400,
        initialFrameWidth: 400,
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: '',

        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/'
        // 配合最新编译的资源文件，你可以实现添加自定义Request Headers,详情https://github.com/HaoChuan9421/ueditor/commits/dev-1.4.3.3
        // headers: {
        //   access_token: '37e7c9e3fda54cca94b8c88a4b5ddbf3'
        // }
      },

      shortcuts_t: [
        {
          text: '今天',
          value: new Date(),
        },
        {
          text: '明天',
          value: () => {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            return date
          },
        },
        {
          text: '后天',
          value: () => {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 2);
            return date
          },
        },
        {
          text: '一周后',
          value: () => {
            const date = new Date()
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            return date
          },
        },
      ]

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    check() {
      if(!this.caseForm.title) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请输入文章标题',
          type: 'warning'
        });
        return false;
      }
      if(!this.caseForm.content) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '发布内容不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.caseForm.shareContent) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请输入分享内容',
          type: 'warning'
        });
        return false;
      }
      if(!this.caseForm.pageViewShow) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请输入初始浏览量',
          type: 'warning'
        });
        return false;
      }
      return true;
    },

    formatDate(date) {
      let d = date.getFullYear()+"-"+(date.getMonth()+1 < 10?'0'+(date.getMonth()+1):date.getMonth()+1)+"-"+(date.getDate() < 10?'0'+date.getDate():date.getDate());
      d += " "+(date.getHours() < 10?'0'+date.getHours():date.getHours())+":"+(date.getMinutes() < 10?'0'+date.getMinutes():date.getMinutes())+":"+(date.getSeconds() < 10?'0'+date.getSeconds():date.getSeconds());
      return d;
    },

    summit() {
      if(this.check()) {
        this.loading = true
        let param = {};
        param['id'] = this.caseForm.id?this.caseForm.id:0;
        param['title'] = this.caseForm.title;
        param['content'] = this.caseForm.content;
        param['shareContent'] = this.caseForm.shareContent;
        param['type'] = this.type;
        param['pageViewShow'] = this.caseForm.pageViewShow;
        param['showTime'] = this.formatDate(this.showTime)
        postFormData(addOrUpdateSuccessfulCase, param).then((data) => {
          let {msg, code} = data
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'success'
            });
            this.$emit('confirm')
          }else {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'warning'
            });
          }
          this.loading = false
        }).catch(()=>{
          this.loading = false
        })
      }
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
